import script from "./SectionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionsView.vue?vue&type=script&setup=true&lang=js"

import "./SectionsView.vue?vue&type=style&index=0&id=2b7df5ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b7df5ae"]])

export default __exports__